import { create } from 'zustand';
import { logAnalyticsEvent } from '@/services/analyticsLogger';

export type PremiumUpsellOpenSource =
  | 'profile_plan_card'
  | 'app_launch_marketing'
  | 'manual';

type PremiumUpsellState = {
  visible: boolean;
  source?: PremiumUpsellOpenSource;
};

type PremiumUpsellActions = {
  open: (payload?: { source?: PremiumUpsellOpenSource }) => void;
  close: () => void;
};

export const usePremiumUpsellStore = create<PremiumUpsellState & PremiumUpsellActions>((set) => ({
  visible: false,
  source: undefined,
  open: (payload) => {
    const source = payload?.source ?? 'manual';
    set({ visible: true, source });
    logAnalyticsEvent('premium_paywall_shown', {
      source: 'marketing_upsell',
      feature: source,
    }).catch(() => {});
  },
  close: () => set({ visible: false }),
}));
